import styled from "styled-components";

export const ContentWrapper = styled.div`
  width: 100%;
  max-width: 68rem;
  margin: 0 auto;
  padding: 1rem;
`;
